require('core-js/es6');
require('core-js/fn/array/includes');
require('url-api-polyfill');

require('react');
require('react-helmet');
require('react-router');
require('react-dom');
require('moment');
window.$ = require('jquery');
require('jquery-migrate');
require('@reverbdotcom/elog').default;
require('jquery-ujs');
require('alt');
require('@reverbdotcom/adyen-cse-js');
require('accounting');
require('raty-js');
require('react-apollo');
require('history');
require('rc-slider');
require('raven-js');
require('react-modal');
require('fuse.js');
require('react-image-crop');
require('apollo-link-http');
require('alt-container');
require('whatwg-fetch');
require('js-cookie');
require('apollo-cache-inmemory');
require('qs');
require('tslib');
window.I18n = require('i18n-js');

require('../../../vendor/assets/javascripts/jquery-powertip/jquery.powertip.js');
require('../../../vendor/assets/javascripts/jquery.fancybox.js');
require('../../../vendor/assets/javascripts/waypoints.min.js');
require('../../../vendor/assets/javascripts/tocca.min.js');
window.PhotoSwipe = require('photoswipe');
window.PhotoSwipeUI_Default = require('photoswipe/dist/photoswipe-ui-default');
require('../../../vendor/assets/javascripts/blankshield.js');
require('../../../vendor/assets/javascripts/jquery.inputmask');
require('../../../vendor/assets/javascripts/jquery.limit.min');
require('../../../vendor/assets/javascripts/jquery.payment');
require('../../../vendor/assets/javascripts/jquery.hoverIntent');
require('../../../vendor/assets/javascripts/jquery.autocomplete');
require('../../../vendor/assets/javascripts/typeahead.jquery');
require('../../../vendor/assets/javascripts/jquery.creditCardValidator');
require('../../../vendor/assets/javascripts/readmore.min');
require('../../../vendor/assets/javascripts/Placeholders.min');
require('../../../vendor/assets/javascripts/jquery.countdown');
require('../../../vendor/assets/javascripts/temporal');
require('../../../vendor/assets/javascripts/jquery.sortable');
require('../../../vendor/assets/javascripts/jquery.ui.widget');
require('../../../vendor/assets/javascripts/jquery.iframe-transport');
require('../../../vendor/assets/javascripts/jquery.fileupload');
require('../../../vendor/assets/javascripts/jquery.cloudinary');
require('../../../vendor/assets/javascripts/attachinary');

// picker.js
require('../../../vendor/assets/javascripts/picker.js');
require('../../../vendor/assets/javascripts/picker.date');
require('../../../vendor/assets/javascripts/picker.time');

require('../../../vendor/assets/javascripts/fotorama.js');
require('../../../vendor/assets/javascripts/owl.carousel.min');

require('components/chartist-with-plugins.js');
require('../../../vendor/assets/javascripts/chosen/chosen.js');

window.Reverb = window.Reverb || {};

// These files are shared by the webpacked admin and reverb
// bundles.
window.Reverb.UI = require('./components/legacy/ui.js').UI;
require('./components/legacy/ui.js').initAll();



// WEBPACK FOOTER //
// ./javascripts/vendor.js